import { render, staticRenderFns } from "./DiscountTemplateModal.vue?vue&type=template&id=0c182c10&scoped=true&"
import script from "./DiscountTemplateModal.vue?vue&type=script&lang=js&"
export * from "./DiscountTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscountTemplateModal.vue?vue&type=style&index=0&id=0c182c10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c182c10",
  null
  
)

export default component.exports